module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_android_02-450-d0e8cf0061df7cac03c5bff70a97cd08.png";